import { DataType } from '@/api/const';
import { getChartOption } from '@/pages/Statistics/components/Chart/chartOption';
import { getCommonMarkPint, getLegend, translateName } from '@/pages/Statistics/components/Chart/helper';
import palette from '@/pages/Statistics/components/Chart/palette';
import { ParamsOption } from '@/pages/Statistics/config';

// 功率因数
export const getCOSQChart = ({ chartData = [], query, unit }: ParamsOption) => {
  const option = getChartOption({
    unit,
    query,
  });

  const { name } = query;
  const colors = palette[DataType.COSQ];

  return {
    ...option,
    legend: {
      ...getLegend({
        show: true,
        name,
        colors,
        chartData,
      }),
      top: 10,
    },
    grid: {
      left: 24,
      right: 24,
      top: 50,
      bottom: 10,
      containLabel: true,
    },
    series: [
      ...chartData.map((item, index) => ({
        type: 'line',
        smooth: true,
        lineStyle: { normal: { width: 2 } },
        color: colors[index],
        name: translateName(Array.isArray(name) ? name[index] : name, item.circuitName),
        data: item.data.map(a => [a.time, a.value]),
        timeResolution: query.aggrby,
        markPoint: getCommonMarkPint(query.btnType),
      })),
    ],
  };
};
